import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import IconButton from 'material-ui/IconButton';
import { fetchIncidents } from '../../../esri/mapHub';
import {
  getCurrentRouteFragment,
  formatAttribute
} from '../../../utils/helpers';
import DataGrid from '../../common/DataGrid';
import gridDefinition from '../../../defaults/datagrids/incidents.json';
import originFields from '../../../defaults/PointOfOriginFields.json';

import theme from '../../../muiTheme';

const styles = {
  invalidHeader: {
    color: theme.palette.accent1Color
  },
  invalidBody: {
    textAlign: 'center',
    padding: '100px'
  }
};

class RelationshipDetails extends Component {
  constructor() {
    super();
    const relationshipInfo = this.getRelationshipInfo(window.location.pathname);
    this.state = {
      loading: null,
      incidents: [],
      isMore: true,
      incidentCount: 0,
      noRelationshipsFound: false,
      relationshipInfo,
      gridDefinition
    };
    console.log(relationshipInfo);
  }

  componentDidMount() {
    this.updateGridDefinitionFields();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.fields !== this.props.fields ||
      prevProps.incidentListColumns !== this.props.incidentListColumns
    ) {
      this.updateGridDefinitionFields();
    }
  }

  updateGridDefinitionFields() {
    const gridDefinitionFields = this.getGridDefinitionFields(
      this.props.incidentListColumns
    );

    this.setState({
      gridDefinition: {
        ...this.state.gridDefinition,
        fields: gridDefinitionFields
      }
    });
  }

  getGridDefinitionFields(incidentListColumns) {
    // loop over incidentListColumns,
    // lookup fields definition object from this.props.fields,
    // and return a new array
    // (intended to update the array used in this.state.gridDefinition.fields)
    if (this.props.fields) {
      return incidentListColumns.map(
        columnName => this.props.fields[columnName]
      );
    }

    return [];
  }

  getRelationshipInfo(path) {
    const keyword = getCurrentRouteFragment(path);
    switch (keyword) {
      case 'complex':
        return { type: keyword, label: 'Complex', lookup: 'complexes' };
      case 'merge':
        return { type: keyword, label: 'Merge', lookup: 'merges' };
      case 'conflict':
        return { type: keyword, label: 'Conflict', lookup: 'conflicts' };
      case 'postfire':
        return { type: keyword, label: 'Post Fire', lookup: 'postfire' };
      case 'providingresponse':
        return {
          type: keyword,
          label: 'Providing Response',
          lookup: 'responses'
        };
      case 'prescribedescape':
        return {
          type: keyword,
          label: 'Prescribed Fire Escape',
          lookup: 'prescribed'
        };
      default:
        console.error('Invalid Relationship Keyword');
        return null;
    }
  }

  updateIncidentList = (incidents, incidentCount, isMore) => {
    this.setState({ incidents, incidentCount, isMore });
    this.incidentsHaveLoaded();
  };

  incidentsHaveLoaded = () => {
    this.setState({ loading: false });
  };

  incidentsAreLoading = () => {
    this.setState({ loading: true });
  };

  getBaseQuery(lookup, currentIncident) {
    if (!currentIncident) return null;

    const ids = currentIncident.derived[lookup].map(incident => incident.id);

    if (!ids.length) {
      // This is a complex (due to IncidentTypeCategory, but has no complex relationships)
      this.setState({ noRelationshipsFound: true });
    }

    const idField = originFields.idFields.incidents;
    console.log(idField);
    const baseClause = gridDefinition.baseQuery
      ? `AND (${gridDefinition.baseQuery})`
      : '';
    return `${idField} IN ('${ids.join("','")}') ${baseClause}`;
  }

  getActions = () => [
    <IconButton
      tooltip="View Incident"
      tooltipPosition="bottom-left"
      key="viewIncidentBtn"
    >
      <i className="grid-action-icon esri-icon-review" />
    </IconButton>
  ];

  render() {
    const {
      loading,
      incidents,
      incidentCount,
      isMore,
      relationshipInfo,
      noRelationshipsFound,
      gridDefinition
    } = this.state;

    if (noRelationshipsFound) {
      return (
        <div style={styles.invalidBody}>
          <h1 style={styles.invalidHeader}>Oops!</h1>
          <p>
            No {relationshipInfo.label} Relationships exist for this incident.
          </p>
        </div>
      );
    }

    const { currentIncident } = this.props;
    const { dataGridOptions } = this.props.appConfig;
    const mapLoaded = this.props.map.loaded;

    if (!mapLoaded || !currentIncident) {
      return null;
    }

    return (
      <Fragment>
        <DataGrid
          title={`Incidents in ${relationshipInfo.label}`}
          api="incident"
          style={{
            ...this.props.style,
            flex: '1 0 100px'
          }}
          badgeColor={theme.palette.accent1Color}
          pollInterval={dataGridOptions.pollingInterval}
          fieldDefinitions={gridDefinition.fields}
          defaultSort={gridDefinition.defaultSort}
          baseQuery={this.getBaseQuery(
            relationshipInfo.lookup,
            currentIncident
          )}
          fetchItems={fetchIncidents}
          loading={loading}
          items={incidents}
          itemCount={incidentCount}
          isMore={isMore}
          pageSize={dataGridOptions.defaultPageSize}
          attributeFormatter={formatAttribute}
          updateItems={this.updateIncidentList}
          onLoadStart={this.incidentsAreLoading}
          actions={this.getActions()}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  map: state.map,
  appConfig: state.config,
  currentIncident: state.incident.currentIncident,
  fields: state.incident.fields,
  incidentListColumns: state.incident.incidentListColumns
});

export default withRouter(connect(mapStateToProps)(RelationshipDetails));



// WEBPACK FOOTER //
// ./src/components/incidents/IncidentDetails/RelationshipDetails.js